import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePenIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22 7.24a.9986.9986 0 0 0-.29-.71l-4.24-4.24a.999.999 0 0 0-.71-.29 1 1 0 0 0-.71.29l-2.83 2.83L2.29 16.05a.9989.9989 0 0 0-.29.71V21a1 1 0 0 0 1 1h4.24a1.0006 1.0006 0 0 0 .76-.29l10.87-10.93L21.71 8a1.1883 1.1883 0 0 0 .22-.33.9933.9933 0 0 0 0-.24.6968.6968 0 0 0 0-.14l.07-.05ZM6.83 20H4v-2.83l9.93-9.93 2.83 2.83L6.83 20ZM18.17 8.66l-2.83-2.83 1.42-1.41 2.82 2.82-1.41 1.42Z"/>
  </SvgIcon>
}

export default LinePenIcon
